import React from 'react';
import PropTypes from 'prop-types';

const UniLogo = ({ color = '#959595', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={23} height={28} fill="none" {...props}>
    <path
      fill={color}
      d="M21.619.639 1.325 0C.526 0-.101.639.013 1.51l3.42 25.617c.115.87.742 1.103 1.426.639l2.736-1.975c.684-.465 1.653-.872 2.736-.814 1.084.058 9.406.64 9.406.64.855.057 1.54-.582 1.653-1.453l1.597-21.899c.114-.87-.513-1.568-1.368-1.626Zm-.4 2.44L19.965 23.35c0 .348-.285.58-.627.465l-6.441-1.394c-.912-.175-1.54-.698-1.654-1.627L9.59 5.635c-.057-.35.228-.698.513-.756l10.49-2.265c.398-.058.626.116.626.465Z"
    />
  </svg>
);

UniLogo.propTypes = {
  color: PropTypes.string
};

export default UniLogo;
